module.exports = __webpack_public_path__ + "img/gcjs.355884a.png";